import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectDetailsContentComponent } from './project-details-content/project-details-content.component';
import { ProjectScenarioConfigurationComponent } from './project-scenario-configuration/project-scenario-configuration.component';
import { ProjectScenarioListComponent } from './project-scenario-list/project-scenario-list.component';
import { ProjectMaterialListComponent } from './project-material-list/project-material-list.component';
import { ProjectScenarioManufacturingComponent } from './project-scenario-manufacturing/project-scenario-manufacturing.component';
import { ProjectScenarioFillDataComponent } from './project-scenario-fill-data/project-scenario-fill-data.component';
import { ProjectScenarioWholesaleDataComponent } from './project-scenario-wholesale-data/project-scenario-wholesale-data.component';
import { ProjectScenarioRetailComponent } from './project-scenario-retail/project-scenario-retail.component';
import { ProjectScenarioConsumerComponent } from './project-scenario-consumer/project-scenario-consumer.component';
import { ProjectScenarioEOLComponent } from './project-scenario-eol/project-scenario-eol.component';
import { ProjectReportChartGlanceComponent } from './project-report-chart-glance/project-report-chart-glance.component';
import { ProjectReportChartGlanceV2Component } from './project-report-chart-glance-v2/project-report-chart-glance-v2.component';
import { ProjectReportGenerationComponent } from './project-report-generation/project-report-generation.component';
import { ProjectPackConversionComponent } from './project-pack-conversion/project-pack-conversion.component';
import { ProjectDetailReportComponent } from './project-detail-report/project-detail-report.component';
import { ProjectDetailsSidebarComponent } from './project-details-sidebar/project-details-sidebar.component';
import { ProductLossComponent } from './product-loss/product-loss.component';
import { ReportInterpretationComponent } from './report-interpretation/report-interpretation.component';

const routes: Routes = [
  {
    path: 'setting',
    pathMatch: 'full',
    component: ProjectDetailsContentComponent,
  },
  {
    path: 'projectSetting',
    pathMatch: 'full',
    component: ProjectDetailsContentComponent,
  },
  {
    path: 'scenario-list',
    component: ProjectScenarioListComponent,
  },
  {
    path: 'scenario-configuration',
    pathMatch: 'full',
    component: ProjectScenarioConfigurationComponent,
  },
  {
    path: 'material-list',
    pathMatch: 'full',
    component: ProjectMaterialListComponent,
  },
  {
    path: 'conversion-list',
    pathMatch: 'full',
    component: ProjectPackConversionComponent,
  },
  {
    path: 'manufacture-list',
    pathMatch: 'full',
    component: ProjectScenarioManufacturingComponent,
  },
  {
    path: 'product-loss',
    pathMatch: 'full',
    component: ProductLossComponent,
  },
  {
    path: 'product-loss-sector',
    pathMatch: 'full',
    component: ProductLossComponent,
  },
  {
    path: 'product',
    pathMatch: 'full',
    component: ProductLossComponent,
  },
  {
    path: 'fill-data-list',
    pathMatch: 'full',
    component: ProjectScenarioFillDataComponent,
  },
  {
    path: 'wholesale-data-list',
    pathMatch: 'full',
    component: ProjectScenarioWholesaleDataComponent,
  },
  {
    path: 'retail-list',
    pathMatch: 'full',
    component: ProjectScenarioRetailComponent,
  },
  {
    path: 'consumer-list',
    pathMatch: 'full',
    component: ProjectScenarioConsumerComponent,
  },
  {
    path: 'end-of-life',
    pathMatch: 'full',
    component: ProjectScenarioEOLComponent,
  },
  {
    // The existing BarChartNew / SpiderChartNew screen — still the one the
    // sidebar links to.
    path: 'chart-at-glance',
    pathMatch: 'full',
    component: ProjectReportChartGlanceComponent,
  },
  {
    // Same screen on the unified GenerateChartReport endpoint. Not in the
    // sidebar — reached from the "Open new version" link in the chart at a
    // glance header, which opens it in a new tab for side-by-side comparison.
    path: 'chart-at-glance-v2',
    pathMatch: 'full',
    component: ProjectReportChartGlanceV2Component,
  },
  {
    path: 'interpretation',
    pathMatch: 'full',
    component: ReportInterpretationComponent,
  },
  {
    path: 'report-generation',
    //pathMatch: 'full',
    component: ProjectReportGenerationComponent,
  },
  {
    path: 'project-detail-report',
    //pathMatch: 'full',
    component: ProjectDetailReportComponent,
  },
  {
    path: 'project-detail-sidebar',
    pathMatch: 'full',
    component: ProjectDetailsSidebarComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProjectDetailsRoutingModule {}
